var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRotateLeft = function SvgArrowRotateLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.196 18.146a7.803 7.803 0 0 0 10.95-1.342 7.8 7.8 0 0 0-1.342-10.95 7.803 7.803 0 0 0-10.95 1.342L4.5 9h5.1v.6h-6v-6h.6v4.8l1.178-1.567.003-.004a8.397 8.397 0 0 1 11.79-1.448 8.397 8.397 0 0 1 1.448 11.79 8.397 8.397 0 0 1-11.79 1.448 8.4 8.4 0 0 1-2.19-2.569l.525-.289A7.8 7.8 0 0 0 7.2 18.15z"
  })));
};
export default SvgArrowRotateLeft;